<template>
    <div>
        <self-back :pageHeaderList="[{'name':'投放媒体设置'}]"></self-back>
        <div class="content" v-loading='loading'>
            <div class="header-wrap">
                <button class="addaccountButton" @click="addaccountEvent">+ 添加媒体</button>
                <el-input placeholder="请输入媒体名称" v-model.trim="keyword" clearable @keydown.enter.native="keyword?accountsListEvent(1):''" @clear="accountsListEvent(1)" size="small" style="width:200px;margin-left:15px">
                    <el-button slot="append" icon="el-icon-search" @click="accountsListEvent(1)" style="padding:0 10px" />
                </el-input>
                <el-input placeholder="请输入成本公司" v-model.trim="company" clearable @keydown.enter.native="company?accountsListEvent(1):''" @clear="accountsListEvent(1)" size="small" style="width:200px;margin-left:15px">
                    <el-button slot="append" icon="el-icon-search" @click="accountsListEvent(1)" style="padding:0 10px" />
                </el-input>
            </div>
            <el-table
                class="table"
                :header-cell-style="{background:'#f5f7fa'}"
                :data="accountList"
                :max-height="tableMaxHeight"
                border
                >
                <el-table-column
                prop="media_name"
                label="媒体名称"
                align='center'
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                align='center'
                label="对应成本公司"
                >
                </el-table-column>
                <el-table-column
                prop="cost_owner"
                align='center'
                label="成本负责人"
                >
                </el-table-column>
                <el-table-column
                align='center'
                label="默认"
                >
                    <template slot-scope="scope">
                        <i class="el-icon-circle-check" v-if="scope.row.is_default==1" style="color: #5c7bfe;font-size: 16px;"></i>
                    </template>
                </el-table-column>
                <el-table-column
                align='center'
                label="操作">
                    <template slot-scope="scope">
                        <button @click="modifyaccountEvent(scope.row)">修改</button>
                        <button v-if="scope.row.del_enable==1" style="background:#FC726D" @click="deleteaccountFlagEvent(scope.row)">删除</button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationBox" style="height: 30px;">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    :page-size="page_size"
                    @current-change="handleCurrentChange"
                    layout="total, prev, pager, next, jumper"
                    :total="total" />
            </div>
        </div>
        <!-- 添加账号 -->
        <el-dialog
            :title="isEdit?'修改媒体':'添加媒体'"
            :visible.sync="addaccountFlag"
            width="30%"
            :close-on-click-modal='false'
            center>
            <div class="dialogBox">
                <div class="dialogitem">
                    <label><em>*</em>媒体名称：</label>
                    <el-input
                        :disabled="isEdit?true:false"
                        placeholder="请输入媒体名称"
                        style="width:67%"
                        v-model.trim="accountName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>对应公司：</label>
                    <el-input
                        placeholder="请输入成本公司名称"
                        style="width:67%"
                        v-model.trim="companyName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label><em>*</em>成本负责人：</label>
                    <el-input
                        placeholder="请输入成本负责人"
                        style="width:67%"
                        v-model.trim="costOwnerName"
                        size='small'
                        clearable>
                    </el-input>
                </div>
                <div class="dialogitem">
                    <label>设为默认：</label>
                    <el-checkbox v-model="isDefault">是</el-checkbox>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelAddaccount" size="mini">取 消</el-button>
                <el-button type="primary" @click="addaccountYes" size="mini">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return{
            addaccountFlag:false,
            deleteaccountFlag:false,
            accountList:[],
            accountName:'',
            page:1,
            page_size:20,
            total:0,
            loading:false,
            isEdit:false,
            vebateId:'',
            companyName:'',
            costOwnerName:'',
            isDefault:false,
            keyword: '',
            company: '',
        }
    },
    computed: {
        // 计算表格最大高度，确保分页控件和Footer可见
        tableMaxHeight() {
            // Header(60) + self-back(50) + padding(30) + button(30) + hint(25) + table-margin(15) + pagination(40) + pagination-margin(15) + footer(70) + footer-margin(10) = 345px
            // 留一些余量，使用 400px（因为账号管理页面有额外的提示信息）
            return window.innerHeight - 260;
        }
    },
    created(){
        this.accountsListEvent(1)
    },
    methods:{
        addaccountEvent(){//点击添加账号按钮
            this.addaccountFlag = true;
            this.isEdit = false;
        },
        deleteaccountFlagEvent(data){//删除账号
            this.$confirm('确定要删除该配置?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$axios.post(this.URL.BASEURL + this.URL.mediaDel,{
                        id: data.id,
                    }).then((res) => {
                        var res=res.data;
                        if(res&& res.errno == 0){
                            this.accountsListEvent(this.page)
                        }else {
                            this.$message({
                                message: res.err,
                                type: 'warning'
                            })
                        }
                    }).catch(()=>{
                    })
                }).catch(() => {
            });
        },
        handleCurrentChange(val){
            this.accountsListEvent(val)
        },
        accountsListEvent(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.mediaList,{
               params:{
                   page: page,
                   page_size: this.page_size,
                   keyword: this.keyword,
                   company: this.company,
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.accountList = res.rst.data;
                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        addaccountYes(){//添加账号
            if(this.accountName == ''){
                this.$message({
                    message: '请输入媒体名称',
                    type: 'fail'
                })
                return
            }
            if(this.costOwnerName == ''){
                this.$message({
                    message: '请输入成本负责人',
                    type: 'fail'
                })
                return
            }
            if(this.isEdit){//编辑
                this.$axios.post(this.URL.BASEURL + this.URL.mediaEdit,{
                    id: this.vebateId,
                    media_name: this.accountName,
                    company: this.companyName,
                    cost_owner: this.costOwnerName,
                    is_default: this.isDefault?1:0
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }else{
                this.$axios.post(this.URL.BASEURL + this.URL.mediaAdd,{
                    media_name: this.accountName,
                    company: this.companyName,
                    cost_owner: this.costOwnerName,
                    is_default: this.isDefault?1:0
                }).then((res) => {
                    var res=res.data;
                    if(res&& res.errno == 0){
                        this.accountsListEvent(this.page)
                        this.cancelAddaccount()
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                })
            }
        },
        cancelAddaccount(){//取消添加账号
            this.addaccountFlag = false;
            this.accountName = '';
            this.companyName = '';
            this.costOwnerName = '';
            this.isDefault = false;
        },
        modifyaccountEvent(data){//修改账号
            this.accountName = data.media_name;
            this.vebateId = data.id;
            this.companyName = data.company;
            this.costOwnerName = data.cost_owner;
            this.isDefault = data.is_default == 1 ? true : false;
            this.isEdit = true;
            this.addaccountFlag = true;
        }
    },
    watch:{

    }
}
</script>
<style lang="scss" scoped>
.content{
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding: 15px 15px 0;
    // display: flex;
    flex-direction: column;
    box-sizing: border-box;
    min-height: calc(100vh - 140px);
    .header-wrap {
        display: flex;
        align-items: center;
    }
    .addaccountButton{
        height: 30px;
        background: #5B7BFE;
        border-radius: 4px;
        color: #FFFFFF;
        font-size: 13px;
        border:none;
        padding:0 10px;
    }
    .table{
        margin-top: 15px;
        button{
            min-width: 48px;
            height: 22px;
            background: #5B7BFE;
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 12px;
            border: none;
            padding: 0 6px;
        }
    }
}
.dialogitem{
    margin-bottom: 20px;
    &:last-of-type{
        margin-bottom: 0;
    }
    label{
        display: inline-block;
        width: 100px;
        color: #202652;
        font-size: 14px;
        line-height: 20px;
        em{
            color: red;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/disposeAdmin/mediaConfigure.vue